import React, { useEffect } from 'react';
import { Box, Paper } from '@mui/material';
import HeaderTraining from '../../components/layout/training/Header';
import BodyTraining from '../../components/layout/training/Body';
import { useAuth } from '../../shared/context';

const page = {
  with: '100%',
  height: 'auto',
};

const ReadDocument = () => {
  const { checkTokenValidity } = useAuth();

  useEffect(() => {
    checkTokenValidity();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Box component={Paper} sx={page} p={2}>
        <HeaderTraining />
        <BodyTraining />
      </Box>
    </>
  );
};

export default ReadDocument;
